module.exports = __webpack_public_path__ + "static/img/组 9@2x(1).ba860d58.png";